import React from "react";
import PT from "prop-types";
import { useAtomValue } from "jotai/utils";
import { promocodeAtom } from "./atoms/promocode";
import { periodAtom } from "./atoms/period";
import QueryRequest from "_c/QueryRequest";
import { usePriceQuery } from "./hooks/usePriceQuery";
import { useNormalizedPrice } from "./hooks/useNormalizedPrice";
import PerMonthPriceInfo from "./PerMonthPriceInfo";
import TrialActivation from "./TrialActivation";
import Payment from "./Payment";
import * as S from "./styled";
import PeriodSelect from "./PeriodSelect";
import { Spin } from "_c/preloader";

const spin = <Spin isLight />;
const SubscribeForm = (props) => {
  const promocode = useAtomValue(promocodeAtom);
  const period = useAtomValue(periodAtom);
  const priceQuery = usePriceQuery({ promocode });
  const priceList = priceQuery.data?.price?.month;
  const price = useNormalizedPrice({
    price: priceQuery.data,
    period,
  });
  const promocodeData = priceQuery.data?.promocode;
  return (
    <S.Wrap isFeaturesHidden={props.isFeaturesHidden}>
      <QueryRequest spin={spin} query={priceQuery}>
        {priceList && <PeriodSelect priceList={priceList} t={props.t} />}
        {price && (
          <PerMonthPriceInfo
            t={props.t}
            pricePerMonth={price?.perMonthFinal}
            pricePerDay={price?.perDayFinal}
            initialPricePerDay={price?.perDayInitial}
            initialPricePerMonth={price?.perMonthInitial}
            period={period}
          />
        )}
        {price && (
          <Payment
            promocodeData={promocodeData}
            promocode={promocodeData?._id}
            t={props.t}
            period={period}
            price={price?.final}
            initialPrice={price?.initial}
            isActive={props.isActive}
            isTrial={props.isTrial}
            user={props.user}
          />
        )}
        {props.allowTrial && (
          <TrialActivation t={props.t} activateTrial={props.activateTrial} />
        )}
      </QueryRequest>
    </S.Wrap>
  );
};
SubscribeForm.propTypes = {
  allowTrial: PT.bool,
  currency: PT.string,
  isActive: PT.bool,
  isTrial: PT.bool,
  activateTrial: PT.func,
  extend: PT.func,
};

export default SubscribeForm;
